// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { UserSignupApi, UserOtpSubmit } from "../../Services/Auth/Login";
// import { image_baseurl } from "../../../Utils/config";
// import { Link } from "react-router-dom";
// import { basicsettinglist, GetAllStates, GetAllCities } from "../../Services/Admin/Admin";
// import BgImg from "./bg-login-img.png";
// import ReusableModal from "../../components/Models/ReusableModal";
// import showCustomAlert from "../../Extracomponents/CustomAlert/CustomAlert";




// const UserSignup = () => {


//   const token = localStorage.getItem("token");
//   const theme = localStorage.getItem("theme");


//   const [themeBackground, setThemeBackground] = useState("#ffffff");


//   useEffect(() => {

//     if (theme) {
//       try {
//         const parsedTheme = JSON.parse(theme);
//         const bgColor = parsedTheme?.sidebarColor || "#ffffff";
//         setThemeBackground(bgColor);
//       } catch (err) {
//         console.error("Theme parse error", err);
//       }
//     }
//   }, []);


//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     fullName: "",
//     email: "",
//     phone: "",
//     referralCode: "",
//     password: "",
//     state: "",
//     city: "",

//   });

//   const [otpInfo, setOtpInfo] = useState({
//     "status": "",
//     "otp": "",
//     "otpmobile": "",
//     "email": "",
//     "message": "",
//   })




//   const [enteredOtp, setEnteredOtp] = useState("")

//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [information, setInformation] = useState([]);

//   const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);

//   const [isReferralEnabled, setIsReferralEnabled] = useState(false);




//   const [state, setState] = useState([])
//   const [city, setCity] = useState([])



//   const togglePasswordVisibility = (e) => {
//     e.preventDefault();
//     setShowPassword(!showPassword);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });

//     validateField(name, value);
//   };

//   const validateField = (name, value) => {
//     let errorMsg = "";

//     // General blank field check first
//     if (value?.trim() === "") {
//       switch (name) {
//         case "email":
//           errorMsg = "Email is required";
//           break;
//         case "phone":
//           errorMsg = "Phone number is required";
//           break;
//         case "password":
//           errorMsg = "Password is required";
//           break;
//         case "fullName":
//           errorMsg = "Full Name is required";
//           break;
//         case "state":
//           errorMsg = "State is required";
//           break;
//         case "city":
//           errorMsg = "City is required";
//           break;
//         default:
//           errorMsg = "This field is required";
//           break;
//       }
//     } else {
//       // Field-specific validation only if not blank
//       switch (name) {
//         case "fullName":
//           if (!/^[A-Za-z ]+$/.test(value)) {
//             errorMsg = "Please enter a valid Full Name ";
//           }
//           break;

//         case "email":
//           if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
//             errorMsg = "Please Enter Valid Email";
//           }
//           break;
//         case "phone":
//           if (!/^\d{10}$/.test(value)) {
//             errorMsg = "Phone number must be 10 digits";
//           }
//           break;
//         case "password":
//           if (
//             !/^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(value)
//           ) {
//             errorMsg =
//               "Password must be at least 8 characters, include a number, an uppercase letter, and a special character";
//           }
//           break;
//         default:
//           break;
//       }
//     }

//     setErrors((prevErrors) => ({ ...prevErrors, [name]: errorMsg }));
//   };


//   const handleSignup = async (e) => {
//     e.preventDefault();
//     const { fullName, email, phone, referralCode, password, state, city } = formData;

//     const newErrors = {};
//     validateField("fullName", fullName);
//     validateField("email", email);
//     validateField("phone", phone);
//     validateField("password", password);
//     validateField("state", state);
//     validateField("city", city);

//     setErrors((prevErrors) => ({
//       ...prevErrors,
//       fullName: newErrors.fullName || errors.fullName,
//       email: newErrors.email || errors.email,
//       phone: newErrors.phone || errors.phone,
//       password: newErrors.password || errors.password,
//       state: newErrors.state || errors.state,
//       city: newErrors.city || errors.city,
//     }));

//     if (Object.values(errors).some((err) => err)) {
//       showCustomAlert("error", "Please correct the errors before submitting");
//       return;
//     }

//     if (isReferralEnabled && !referralCode) {
//       showCustomAlert("error", "Referral code is required.");
//       return;
//     }
//     try {
//       const ResData = await UserSignupApi({
//         FullName: fullName,
//         Email: email,
//         PhoneNo: phone,
//         password,
//         state,
//         city,
//         token: referralCode || "",
//         clientcome: 1
//       });


//       if (!ResData) {
//         throw new Error("No response received from the server");
//       }

//       if (ResData.status) {
//         if (!ResData.otp || !ResData.email) {
//           throw new Error("Invalid response: OTP or email missing");
//         }

//         showCustomAlert("success", "OTP has been sent to your mobil/email. If you don’t see the email, check your spam or junk folder.");
//         setOtpInfo({
//           status: ResData.status,
//           otp: ResData.otp,
//           otpmobile: ResData.otpmobile || "",
//           email: ResData.email,
//           message: ResData.message || "",
//         });
//         setIsOtpModalOpen(true);
//       } else {
//         showCustomAlert("error", ResData.message || "Signup failed. Please try again.");
//       }
//     } catch (error) {
//       showCustomAlert("error", error.response.data.message || "Something went wrong. Please try again.");
//     }
//   };


//   const handleOtpSubmit = async (e) => {
//     e.preventDefault();

//     if (!enteredOtp) {
//       showCustomAlert("error", "Please enter OTP before submitting")
//       return;
//     }

//     try {

//       if (otpInfo.otp == enteredOtp) {
//         const otpSubmit = await UserOtpSubmit({
//           email: otpInfo.email,
//           otp: enteredOtp,
//         });
//         showCustomAlert("Success", "OTP verification successful!", navigate, "/user-login")
//         setIsOtpModalOpen(false);
//       } else {
//         showCustomAlert("error", "Invalid OTP, please try again!")
//       }
//     } catch (error) {
//       showCustomAlert("error", "Something went wrong, please try again!")
//     }
//   };



//   const getStatedata = async () => {
//     try {
//       const response = await GetAllStates(token);
//       if (response) {
//         setState(response);

//       }
//     } catch (error) {
//       console.log("error");
//     }
//   }



//   const getCitydata = async () => {
//     try {
//       const response = await GetAllCities(formData.state, token);
//       if (response) {
//         setCity(response);

//       }
//     } catch (error) {
//       console.error("Error fetching cities:", error);
//     }
//   };


//   const getSettingList = async () => {
//     try {

//       const response = await basicsettinglist(token);
//       if (response.status) {
//         localStorage.setItem("theme", JSON.stringify(response?.Theme));
//         setInformation(response.data);
//       }
//     } catch (error) {
//       console.log("error", error);
//     }
//   };

//   useEffect(() => {
//     if (formData.state) {
//       getCitydata()
//     }
//   }, [formData.state])




//   useEffect(() => {
//     getSettingList();
//     getStatedata()
//   }, []);


//   return (
//     <div className="main-login" style={{
//       background: themeBackground,
//       minHeight: "100vh",
//       minWidth: "100vh",
//       width: "100%",
//       overflowY: "auto",
//       padding: "20px",
//       transition: "background 0.4s ease-in-out"
//     }}>
//       <div className="row align-items-center h-100 ">
//         <div className="col-lg-12 mx-auto">
//           <div className="bg-login">
//             <div className="section-authentication-signin d-flex align-items-center justify-content-center my-5 my-lg-0">
//               <div className="container-fluid ">
//                 <div className="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
//                   <div className="col mx-auto">
//                     <div className="card mb-0 new-bdr">
//                       <div className="card-body new-bg">
//                         <div className="p-4">
//                           <div className="mb-5 text-center">
//                             <img
//                               style={{ width: "180px" }}
//                               src={`${image_baseurl}uploads/basicsetting/${information[0]?.logo}`}
//                               alt="Company Logo"
//                             />
//                           </div>
//                           <div className="form-body lbl-colr2">
//                             <form onSubmit={handleSignup}>
//                               {[
//                                 { label: "Full Name", name: "fullName", type: "text" },
//                                 { label: "Email", name: "email", type: "text" },
//                                 { label: "Phone", name: "phone", type: "text" },
//                                 { label: "State", name: "state", type: "select" },
//                                 { label: "City", name: "city", type: "select" },
//                                 { label: "Password", name: "password", type: "password" },
//                               ].map((field) => (
//                                 <div className="col-12 mb-3" key={field.name}>
//                                   <label className="form-label">{field.label}<span className="text-danger">*</span></label>

//                                   {field.name === "password" ? (
//                                     <div className="input-group">
//                                       <input
//                                         type={showPassword ? "text" : "password"}
//                                         className={`form-control border-end-0 ${errors.password ? "is-invalid" : ""}`}
//                                         name="password"
//                                         value={formData.password}
//                                         onChange={handleChange}
//                                         placeholder="Enter Password"
//                                       />
//                                       <button
//                                         type="button"
//                                         onClick={togglePasswordVisibility}
//                                         className="input-group-text bg-transparent bg-grn"
//                                       >
//                                         <i className={`bx ${showPassword ? "bx-show" : "bx-hide"}`} />
//                                       </button>
//                                     </div>
//                                   ) : field.name === "state" ? (
//                                     <select
//                                       className={`form-control ${errors.state ? "is-invalid" : ""}`}
//                                       name="state"
//                                       value={formData.state}
//                                       onChange={handleChange}
//                                     >
//                                       <option value="">Select State</option>
//                                       {state?.map((state, index) => (
//                                         <option key={index} value={state.name}>
//                                           {state.name}
//                                         </option>
//                                       ))}
//                                     </select>
//                                   ) : field.name === "city" ? (
//                                     <select
//                                       className={`form-control ${errors.city ? "is-invalid" : ""}`}
//                                       name="city"
//                                       value={formData.city}
//                                       onChange={handleChange}
//                                     >
//                                       <option value="">Select City</option>
//                                       {city?.map((city, index) => (
//                                         <option key={index} value={city.city}>
//                                           {city.city}
//                                         </option>
//                                       ))}
//                                     </select>

//                                   ) : (
//                                     <input
//                                       type={field.type}
//                                       className={`form-control ${errors[field.name] ? "is-invalid" : ""}`}
//                                       name={field.name}
//                                       value={formData[field.name]}
//                                       onChange={handleChange}
//                                       placeholder={`Enter your ${field.label}`}
//                                     />
//                                   )}

//                                   {errors[field.name] && <div className="invalid-feedback">{errors[field.name]}</div>}
//                                 </div>
//                               ))}


//                               <div className="col-12 mb-3">
//                                 <div className="form-check">
//                                   <input
//                                     type="checkbox"
//                                     className="form-check-input"
//                                     id="enableReferral"
//                                     checked={isReferralEnabled}
//                                     onChange={() => {
//                                       setIsReferralEnabled(!isReferralEnabled);
//                                       if (isReferralEnabled) {
//                                         setFormData(prev => ({
//                                           ...prev,
//                                           referralCode: ''
//                                         }));
//                                       }
//                                     }}
//                                   />
//                                   <label className="form-check-label colr-W" htmlFor="enableReferral">
//                                     Do you have a Referral Code?
//                                   </label>
//                                 </div>
//                               </div>

//                               {isReferralEnabled && (
//                                 <div className="col-12 mb-3">
//                                   <label className="form-label">Referral Code</label>
//                                   <input
//                                     type="text"
//                                     className="form-control"
//                                     name="referralCode"
//                                     value={formData.referralCode}
//                                     onChange={handleChange}
//                                     placeholder="Enter Referral Code"
//                                   />
//                                 </div>
//                               )}

//                               <div className="col-12 d-grid">
//                                 <button type="submit" className="btn btn-primary new-btn">
//                                   Sign Up
//                                 </button>
//                               </div>
//                             </form>
//                           </div>
//                           <div className="text-center mt-3">
//                             <p className="colr-W">
//                               Already have an account?
//                               <Link to="/user-login" className="btn btn-link text-light text-decoration-underline p-0">
//                                 {" "}
//                                 Sign in
//                               </Link>
//                             </p>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {isOtpModalOpen && (
//         <ReusableModal
//           show={isOtpModalOpen}
//           onClose={() => setIsOtpModalOpen(false)}
//           title="Enter OTP"
//           body={
//             <form>
//               <div className="row">
//                 <div className="col-md-12">
//                   <label htmlFor="otp">Enter OTP</label>
//                   <span className="text-danger">*</span>
//                   <div className="d-flex justify-content-between mt-2">
//                     {Array.from({ length: 6 }, (_, i) => (
//                       <input
//                         key={i}
//                         type="text"
//                         maxLength="1"
//                         className="form-control text-center p-2"
//                         style={{ width: "45px", height: "45px", fontSize: "18px" }}
//                         value={enteredOtp[i] || ""}
//                         onChange={(e) => {
//                           const value = e.target.value.replace(/[^0-9]/g, "");
//                           const newOtp = enteredOtp.split("");
//                           newOtp[i] = value;
//                           setEnteredOtp(newOtp.join(""));
//                           // Auto focus next input
//                           if (value && e.target.nextSibling) {
//                             e.target.nextSibling.focus();
//                           }
//                         }}
//                       />
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </form>
//           }
//           footer={
//             <>
//               <button
//                 type="button"
//                 className="btn btn-light"
//                 onClick={() => setIsOtpModalOpen(false)}
//               >
//                 Close
//               </button>
//               <button
//                 type="button"
//                 className="btn btn-primary"
//                 onClick={handleOtpSubmit}
//               >
//                 Submit
//               </button>
//             </>
//           }
//         />
//       )}

//     </div>
//   );
// };

// export default UserSignup;





import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { UserLoginApi } from "../../Services/Auth/Login";
import { image_baseurl } from "../../../Utils/config";
import { Link } from "react-router-dom";
import { basicsettinglist } from "../../Services/Admin/Admin";
import $ from "jquery";
import BgImg from "./bg-login-img.png";
import showCustomAlert from "../../Extracomponents/CustomAlert/CustomAlert";
import { UserPhoneNumberLogin, UserVerifyOtp } from "../../Services/Auth/Login";
import ReusableModal from "../../components/Models/ReusableModal";

const Userlogin = () => {
  const theme = localStorage.getItem("theme");
  const [themeBackground, setThemeBackground] = useState("#ffffff");
  const [loginMethod, setLoginMethod] = useState("otp"); 

  useEffect(() => {
    if (theme) {
      try {
        const parsedTheme = JSON.parse(theme);
        const bgColor = parsedTheme?.sidebarColor || "#ffffff";
        setThemeBackground(bgColor);
      } catch (err) {
        console.error("Theme parse error", err);
      }
    }
  }, []);

  const navigate = useNavigate();
  const [email, setemail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [information, setInformation] = useState([]);

  const [phone, setPhone] = useState("");
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [enteredOtp, setEnteredOtp] = useState("");

  const [resendTimer, setResendTimer] = useState(30);
  const [canResendOtp, setCanResendOtp] = useState(false);

  const inputRefs = useRef([]);

  const togglePasswordVisibility = (e) => {
    e.preventDefault();
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (email.trim() === "" || password.trim() === "") {
      showCustomAlert(
        "error",
        "Please enter both email and password",
        navigate,
        null,
      );
      return;
    }

    setIsLoading(true);
    const ResData = await UserLoginApi({ UserName: email, password: password });
    setIsLoading(false);

    if (ResData.status) {
      localStorage.setItem("token", ResData.data?.token);
      localStorage.setItem("id", ResData.data?.id);
      localStorage.setItem("Role", "USER");
      localStorage.setItem("aliceredirecturl", ResData.data?.aliceredirecturl);
      localStorage.setItem("angleredirecturl", ResData.data?.angleredirecturl);
      localStorage.setItem(
        "upstoxredirecturl",
        ResData.data?.upstoxredirecturl,
      );
      localStorage.setItem(
        "zerodharedirecturl",
        ResData.data?.zerodharedirecturl,
      );

      showCustomAlert(
        "success",
        "Sign up successful!",
        navigate,
        "/user/dashboard",
      );
    } else {
      showCustomAlert("error", ResData.message, navigate, null);
    }
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();

    if (!phone) {
      showCustomAlert("error", "Please enter phone number");
      return;
    }

    setIsLoading(true);

    try {
      const res = await UserPhoneNumberLogin({
        PhoneNo: phone,
        token: null,
        utmSource: null,
      });

      setIsLoading(false);

      if (res.status) {
        showCustomAlert("success", "OTP sent successfully");
        setIsOtpModalOpen(true);
      } else {
        showCustomAlert("error", res.data.message);
      }
    } catch (err) {
      console.log("error", err);
      setIsLoading(false);
      showCustomAlert("error", err.response.data.message);
    }
  };

  const handleOtpVerify = async () => {
    if (!enteredOtp || enteredOtp.length !== 6) {
      showCustomAlert("error", "Enter valid OTP");
      return;
    }

    try {
      const res = await UserVerifyOtp({
        otp: enteredOtp,
        PhoneNo: phone,
        devicetoken: null,
      });

      if (res.status) {
        localStorage.setItem("token", res.data?.token);
        localStorage.setItem("id", res.data?.id);
        localStorage.setItem("Role", "USER");

        showCustomAlert(
          "success",
          "Sign Up successful!",
          navigate,
          "/user/dashboard",
        );

        setIsOtpModalOpen(false);
      } else {
        showCustomAlert("error", res.message || "Invalid OTP");
      }
    } catch (err) {
      showCustomAlert("error", "OTP verification failed");
    }
  };

  const getsettinglist = async () => {
    try {
      let token = "";
      const response = await basicsettinglist(token);
      if (response.status) {
        localStorage.setItem("theme", JSON.stringify(response?.Theme));

        const faviconElement = document.querySelector("link[rel='icon']");
        if (faviconElement) {
          faviconElement.href =
            image_baseurl + "uploads/basicsetting/" + response.data[0].favicon;

          $(".companyName").html(response.data[0].from_name);
        } else {
          console.log("Favicon element not found");
        }

        setInformation(response.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getsettinglist();
  }, []);

  const handleResendOtp = async () => {
    if (!canResendOtp) return;
    setResendTimer(30);
    setCanResendOtp(false);

    if (!phone) {
      showCustomAlert("error", "Phone number missing");
      return;
    }

    setIsLoading(true);

    try {
      const res = await UserPhoneNumberLogin({
        PhoneNo: phone,
        token: null,
        utmSource: null,
      });

      setIsLoading(false);

      if (res.status) {
        showCustomAlert("success", "OTP resent successfully");
        setEnteredOtp("");
        inputRefs.current[0]?.focus();
      } else {
        showCustomAlert("error", res.data.message);
      }
    } catch (err) {
      setIsLoading(false);
      showCustomAlert("error", "Failed to resend OTP");
    }
  };

  useEffect(() => {
    if (!isOtpModalOpen || canResendOtp) return;

    const interval = setInterval(() => {
      setResendTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setCanResendOtp(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOtpModalOpen, canResendOtp]);

  return (
    <div
      className="main-login"
      style={{
        background: themeBackground,
        minHeight: "100vh",
        width: "100%",
        transition: "background 0.4s ease-in-out",
      }}
    >
      <div className="row align-items-center h-100">
        <div className="col-lg-12 mx-auto">
          <div className="bg-login">
            <div className="section-authentication-signin d-flex align-items-center justify-content-center my-5 my-lg-0">
              <div className="container-fluid">
                <div className="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
                  <div className="col mx-auto">
                    <div className="card mb-0 new-bdr">
                      <div className="card-body new-bg">
                        <div className="p-4">
                          {/* Logo */}
                          <div className="mb-4 text-center">
                            <img
                              style={{ width: "180px" }}
                              src={`${image_baseurl}uploads/basicsetting/${information[0]?.logo}`}
                              alt="Logo"
                            />
                          </div>

                          <div className="form-body lbl-colr">
                            {/* OTP Login Form */}
                            {loginMethod === "otp" && (
                              <form
                                className="row g-3"
                                onSubmit={handleSendOtp}
                              >
                                <div className="col-12">
                                  <label className="form-label">
                                    Mobile Number
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Enter Mobile Number"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                  />
                                </div>

                                <div className="col-12">
                                  <div className="d-grid">
                                    <button
                                      type="submit"
                                      className="btn btn-primary new-btn"
                                      disabled={isLoading}
                                    >
                                      {isLoading
                                        ? "Sending OTP..."
                                        : "Send OTP"}
                                    </button>
                                  </div>
                                </div>

                                <div className="col-12 text-center mt-3">
                                  <p className="mb-0">
                                   Already have an account?{" "}
                                    <Link
                                      to="/user-login"
                                      className="btn btn-link text-light text-decoration-underline p-0"
                                    >
                                      Sign in
                                    </Link>
                                  </p>
                                </div>
                              </form>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isOtpModalOpen && (
        <ReusableModal
          show={isOtpModalOpen}
          onClose={() => {
            setIsOtpModalOpen(false);
            setEnteredOtp("");
          }}
          title="Enter OTP"
          modalClass="modal-lg"
          body={
            <form>
              <div
                className="row justify-content-center align-items-center"
                style={{ minHeight: "300px" }}
              >
                <div className="col-md-10 text-center">
                  <label className="fw-bold mb-4 fs-5">Enter OTP</label>

                  <div className="d-flex justify-content-between mt-3">
                    {Array.from({ length: 6 }, (_, i) => (
                      <input
                        key={i}
                        ref={(el) => (inputRefs.current[i] = el)}
                        type="text"
                        maxLength="1"
                        className="form-control text-center"
                        style={{
                          width: "60px",
                          height: "55px",
                          fontSize: "20px",
                          fontWeight: "600",
                        }}
                        value={enteredOtp[i] || ""}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, "");
                          const newOtp = enteredOtp.split("");
                          newOtp[i] = value;
                          setEnteredOtp(newOtp.join(""));

                          if (value && i < 5) {
                            inputRefs.current[i + 1].focus();
                          }
                        }}
                        onKeyDown={(e) => {
                          if (
                            e.key === "Backspace" &&
                            !enteredOtp[i] &&
                            i > 0
                          ) {
                            inputRefs.current[i - 1].focus();
                          }
                        }}
                      />
                    ))}
                  </div>

                  <div className="mt-4">
                    {canResendOtp ? (
                      <span
                        role="button"
                        className="fw-semibold text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={handleResendOtp}
                      >
                        Resend OTP
                      </span>
                    ) : (
                      <span className="text-primary fw-semibold">
                        Resend OTP in {resendTimer}s
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </form>
          }
          footer={
            <>
              <button
                className="btn btn-light"
                onClick={() => setIsOtpModalOpen(false)}
              >
                Close
              </button>

              <button className="btn btn-primary" onClick={handleOtpVerify}>
                Verify OTP
              </button>
            </>
          }
        />
      )}
    </div>
  );
};

export default Userlogin;
